import PropTypes from 'prop-types'
import React from 'react'

import { Input, cn } from 'twyne-new.ui'

import Dropzone from './Dropzone'
import { inputThreshold } from './thresholdConfig'

const NewKeyValuePropTypes = {
  path: PropTypes.string,
  id: PropTypes.number,
  value: PropTypes.string,
  setValueName: PropTypes.func,
  dropReference: PropTypes.func,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
}

export default function NewKeyValue({ path, id, value, setNewKeyValue, dropReference, isOver, canDrop }) {
  return <div className='relative'>
    <Input
      className={cn(canDrop && !isOver && 'twy-bg-base-accent', isOver && 'opacity-0')}
      name="input"
      placeholder="Drop the model to parse this property or enter a static value."
      value={value}
      onChange={e => setNewKeyValue(e.target.value)}
      required
    />
    {canDrop || isOver ? <>
      <Dropzone
        path={path}
        id={id}
        dropReference={dropReference}
        isOver={isOver}
        thresholdConfig={inputThreshold}
      />
    </> : null}
  </div>
}

NewKeyValue.propTypes = NewKeyValuePropTypes
